
import React from 'react';
import { CONTENT } from '../content';

const Werkwijze: React.FC = () => {
  return (
    <div className="py-32 bg-white relative overflow-hidden">
      {/* Subtiel decoratief element */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-accent/5 speels-blob pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-24">
          <span className="text-accent font-bold tracking-[0.4em] text-[10px] uppercase mb-6 block">{CONTENT.werkwijze.badge}</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-8" dangerouslySetInnerHTML={{ __html: CONTENT.werkwijze.title }}></h2>
          <div className="w-24 h-0.5 bg-accent mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {CONTENT.werkwijze.steps.map((item, idx) => (
            <div key={idx} className="bg-liza-bg/40 p-8 rounded-[2rem] border border-accent-light/60 flex flex-col items-center text-center hover:bg-liza-bg/70 hover:shadow-lg transition-all duration-500 group">
              <div className="flex-shrink-0 w-14 h-14 bg-accent-light text-primary rounded-full flex items-center justify-center font-serif text-xl font-bold mb-6 transition-transform duration-500 group-hover:scale-110 group-hover:bg-primary group-hover:text-white">
                {item.nr}
              </div>
              <h3 className="text-xl font-serif mb-4 text-primary">{item.title}</h3>
              <p className="text-gray-500 leading-relaxed font-light text-sm">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center max-w-3xl mx-auto">
          <p className="italic text-gray-500 text-lg font-light" dangerouslySetInnerHTML={{ __html: CONTENT.werkwijze.footerQuote }}>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Werkwijze;
